export default __webpack_public_path__ + "static/media/equipment-temp.bee51bcd.jpg";